export default __webpack_public_path__ + "static/media/dp.65c32b83.png";